import { api } from '../../core/network/api';

/** Run lifecycle status. */
export type DungeonRunStatus = 'ACTIVE' | 'CLEARED' | 'FAILED';

/** A live run's state. */
export interface DungeonRunState {
  id: string;
  dungeonId: string;
  stage: number;
  totalStages: number;
  status: DungeonRunStatus;
  hp: number;
  maxHp: number;
}

/** One dungeon as shown in the catalog. */
export interface DungeonCatalogEntry {
  id: string;
  name: string;
  blurb: string;
  unlockLevel: number;
  nerveCost: number;
  totalStages: number;
  rewardCash: number;
  rewardXp: number;
  firstClearPremium: number;
  stages: { enemyName: string; isKingpin: boolean }[];
  locked: boolean;
  /** Epoch ms until this raid can be run again (72h after a clear); null = available. */
  cooldownUntil: number | null;
  /** ms remaining on the cooldown; 0 when available. */
  availableIn: number;
}

/** GET /api/dungeons */
export interface DungeonListResult {
  dungeons: DungeonCatalogEntry[];
  activeRun: DungeonRunState | null;
}

/** GET /api/dungeons — catalog + the caller's active run. Starting/advancing a
 *  run now happens through the interactive tactical arena (see mobfight-api's
 *  startRaid/continueRaid) rather than through this REST resource. */
export const fetchDungeons = () => api.get<DungeonListResult>('/dungeons');
